export default __webpack_public_path__ + "static/media/mdi_coupon.8fefac88.svg";